import PropTypes from "prop-types";
import {
    selectCiudades,
    selectDepartamentos,
} from "../../../services/personas-service";

import { Col, Row } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "../../../../../core/helpers/message-helper";
import InputController from "../../../../../core/ui/components/InputController";
import SelectController from "../../../../../core/ui/components/SelectController";

const REQUIRED_RULE = {
    required: "Este campo es requerido",
};

const GeneralTab = ({ errors, control, selects, persona, setValue }) => {
    const [departamentos, setDepartamentos] = useState([]);
    const [ciudades, setCiudades] = useState([]);

    async function consultarDepartamento(id_pais) {
        setValue("departamento_id", "");
        setValue("ciudad_id", "");
        const resp = await selectDepartamentos(id_pais);
        if (!resp.status) return toast.error(resp.message);
        setDepartamentos(resp.data);
    }

    async function consultarCiudad(id_departamento) {
        setValue("ciudad_id", "");
        const resp = await selectCiudades(id_departamento);
        if (!resp.status) return toast.error(resp.message);
        setCiudades(resp.data);
    }

    useEffect(async () => {
        if (!persona.pais) return;

        await consultarDepartamento(persona.pais.id);
        await consultarCiudad(persona.departamento.id);
        setValue("ciudad_id", {
            label: persona.ciudad.nombre,
            value: persona.ciudad.id,
        });

        setValue("departamento_id", {
            label: persona.departamento.nombre,
            value: persona.departamento.id,
        });
    }, [persona]);

    return (
        <Row>
            <InputController
                type="hidden"
                name="id"
                errors={errors}
                control={control}
            />
            <Col sm={6}>
                <InputController
                    label="Nombres"
                    errors={errors}
                    control={control}
                    name="nombres"
                    rules={REQUIRED_RULE}
                    placeholder="Nombres"
                />
            </Col>
            <Col sm={6}>
                <InputController
                    label="Apellidos"
                    errors={errors}
                    control={control}
                    name="apellidos"
                    rules={REQUIRED_RULE}
                    placeholder="Apellidos"
                />
            </Col>
            <Col sm={6}>
                <InputController
                    type="date"
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    name="fecha_nace"
                    label="Fecha de nacimiento"
                />
            </Col>
            <Col sm={6}>
                <InputController
                    type="date"
                    errors={errors}
                    control={control}
                    name="expedicion_documento"
                    label="Fecha expedición documento"
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    label="Tipo de documento"
                    options={selects.tiposDocumentos}
                    name="parametro_tipo_documento_id"
                />
            </Col>
            <Col sm={6}>
                <InputController
                    errors={errors}
                    name="documento"
                    label="Documento"
                    control={control}
                    rules={REQUIRED_RULE}
                    placeholder="Documento de Identidad"
                />
            </Col>
            <Col sm={6}>
                <InputController
                    label="Telefono"
                    errors={errors}
                    control={control}
                    name="telefono"
                    rules={REQUIRED_RULE}
                    placeholder="Telefono"
                />
            </Col>
            <Col sm={6}>
                <InputController
                    label="Email"
                    errors={errors}
                    control={control}
                    name="email"
                    rules={REQUIRED_RULE}
                    placeholder="Correo electronico"
                />
            </Col>
            <Col sm={6}>
                <InputController
                    label="Dirección"
                    errors={errors}
                    control={control}
                    name="direccion"
                    rules={REQUIRED_RULE}
                    placeholder="Dirección"
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    label="Genero"
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    options={selects.generos}
                    name="parametro_genero_id"
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    label="Pais"
                    name="pais_id"
                    errors={errors}
                    control={control}
                    options={selects.paises}
                    onChange={(pais) => consultarDepartamento(pais.value)}
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    errors={errors}
                    control={control}
                    label="Departamento"
                    name="departamento_id"
                    onChange={(departamento) =>
                        consultarCiudad(departamento.value)
                    }
                    options={departamentos.map((departamento) => {
                        return {
                            label: departamento.nombre,
                            value: departamento.id,
                        };
                    })}
                />
            </Col>
            <Col sm={6}>
                <SelectController
                    label="Ciudad"
                    name="ciudad_id"
                    errors={errors}
                    control={control}
                    rules={REQUIRED_RULE}
                    options={ciudades.map((ciudad) => {
                        return {
                            label: ciudad.nombre,
                            value: ciudad.id,
                        };
                    })}
                />
            </Col>
        </Row>
    );
};

GeneralTab.propTypes = {
    errors: PropTypes.object,
    control: PropTypes.object,
    selects: PropTypes.object,
    persona: PropTypes.object,
    setValue: PropTypes.func,
};

export default GeneralTab;
